import { FunnelPanel } from '@/components/admin/FunnelPanel';

export default function FunnelPage() {
  return (
    <section className="flex flex-col gap-4">
      <header>
        <h2 className="text-2xl font-semibold tracking-tight">스테이지 진행 퍼널</h2>
        <p className="text-sm text-muted-foreground">
          가입 완료 → 출석 1회+ → Stage 1/10/20/30/40/50+ 클리어 전환율.
        </p>
      </header>
      <FunnelPanel />
    </section>
  );
}
